<style>
.post-update-modal > .ivu-modal > .ivu-modal-content > .ivu-modal-footer {
  padding: 0;
}

.post-update-modal > .ivu-modal > .ivu-modal-content > .ivu-modal-body {
  padding-top: 0px;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
}

.post-update-modal > .ivu-modal > .ivu-modal-content > .ivu-modal-header {
  padding: 0;
  border: 0;
}

.post-update-modal > .ivu-modal > .ivu-modal-content > .ivu-modal-close {
  z-index: 9;
}

.careplan-image {
  height: 60px !important;
  width: 60px !important;
  background: #d8d8d8;
  margin-right: 10px;
  border-radius: 15%;
}

.user-image {
  border-radius: 50%;
}

.post-item__header {
  display: flex;
}

.header-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: start;
  width: 100%;
}

.truncate-3 {
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-weight: 300;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  overflow: hidden;
}
</style>

<template>
  <!-- <app-layout class="post-update-component"> -->
  <!-- <Row type="flex" justify="center"> -->
  <!-- <Col :span="24" v-if="activeCareplan"> -->
  <!-- <PostItemFormComponent :post-avatar="careplanAvatar"
          :post-name="careplanTitle"
          :post-to-value="careplanTitle"
  :post-type="careplanType"></PostItemFormComponent>-->

  <ModalHolder
    m-top="60"
    :title="''"
    :is-show="showModal"
    :mWidth="'50%'"
    :mHeight="'65vh'"
    :closable="false"
    @on-close="closeModal"
    class="post-update-modal"
  >
    <template slot="mheader">
      <div class="post-item__header" v-if="activeCareplan">
        <div style="width: 90%; display: flex;">
          <div
            v-if="activeCareplanType == 'report_concern'"
            class="user-image"
            style="text-align: center"
          >
            <img :src="bullhorn" />
          </div>
          <div style="display: flex; justify-content: center; align-items: center;" v-else>
            <img
              :src="careplanAvatar"
              class="careplan-image"
              :class="activeCareplanType == 'journal' || activeCareplanType == 'private_journal' ? 'user-image' : ''"
            />
          </div>

          <div class="header-content" v-if="activeCareplan">
            <div
              style="display: flex; flex-direction: column;"
              v-if="activeCareplanType == 'journal' || activeCareplanType == 'private_journal'"
            >
              <strong style="margin-bottom: 6px;">{{activeCareplan.title}}</strong>
              <small v-if="activeCareplanType == 'private_journal'">Private Timeline</small>
              <small v-else>Public Timeline</small>
            </div>
            <div v-else-if="reportType == 'concern'">
              <strong>Report Concern</strong>
            </div>
            <div v-else-if="reportType == 'hero'">
              <strong>Nominate a Hero</strong>
            </div>
            <div style="margin-bottom: 6px;" v-else>
              <strong>{{activeCareplan.title}}</strong>
            </div>
            <span
              v-if="activeCareplanType != 'journal' && activeCareplanType != 'private_journal' && activeCareplanType != 'report_concern'"
              class="truncate-3"
              style="font-size:14px;width:100%"
            >{{activeCareplan.description}}</span>
          </div>
        </div>
        <div style="width: 10%; display: flex; justify-content: flex-end;">
          <img
            alt=" "
            class="pointer"
            @click="closeModal"
            style="height:25px; width:25px;"
            src="@/assets/close.png"
          />
        </div>
      </div>
    </template>
    <template slot="mcontent">
      <PostItemFormComponent
        ref="postItemForm"
        @isUploadingImages="onImageLoading"
        :post-type="careplanType"
        :isAdmin="isAdmin"
      ></PostItemFormComponent>
    </template>
    <template slot="mfooter">
      <div class="action-buttons">
        <Button
          type="primary"
          class="action-button__post"
          v-on:click="postItemForm.validatePost()"
          :disabled="isLoadingImages"
          :loading="isLoadingPostActivity"
        >Post</Button>
      </div>
    </template>
  </ModalHolder>
  <!-- </Col> -->
  <!-- </Row> -->
  <!-- </app-layout> -->
</template>

<script>
import Utils from "@/utils.js";
import PostItemFormComponent from "@/components/PostItemFormComponent";
import ModalHolder from "@/components/ModalHolderComponent";
import  { mapGetters } from "vuex"

export default {
  name: "PostUpdateComponent",
  components: {
    PostItemFormComponent,
    ModalHolder
  },
  data() {
    return {
      groupID: Cons[0].GROUP_ID,
      postToValue: "",
      careplanTitle: "",
      careplanAvatar: null,
      careplanType: null,
      showInitialPage: true,
      isAdmin: false,
      isLoadingImages: false
    };
  },
  watch: {
    showModal(n) {
      if (n) {
        this.$store.commit("base/setLoadingPage", true, { root: 1 });
        this.$store
          .dispatch("feed/getCareplanInfo", this.careplanId)
          .then(res => {
            this.$store.commit("base/setLoadingPage", false, { root: 1 });
            this.isAdmin = !this.checkIfCreator(res) || this.isUserAdmin(res);
            this.getPostToValue(this.activeCareplan);
            this.getCareplanAvatar(this.activeCareplan);
          })
          .finally(() => {
            this.$store.commit("base/setLoadingPage", false, { root: 1 });
          });
      }
    }
  },
  computed: {
    ...mapGetters("feed", ["isLoadingPostActivity"]),
    activeCareplanType() {
      return this.activeCareplan.type;
    },
    postItemForm() {
      return this.$refs.postItemForm;
    },
    activeCareplan: {
      get() {
        return this.$store.state.feed.activeCareplan;
      }
    },
    bullhorn: {
      get() {
        return require("@/assets/bullhorn-black.png");
      }
    },
    shareAStory: {
      get() {
        return require("@/assets/share-img.png");
      }
    },
    reportType: {
      get() {
        return this.$route.query.type;
      }
    },
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    activeCareplan: {
      get() {
        return this.$store.state.feed.activeCareplan;
      }
    },
    careplanId: {
      get() {
        // return this.$route.params.cid
        return this.$route.params.cid || this.$route.query.post;
      }
    },
    showModal: {
      get() {
        return this.$store.state.publicModule.showPostItemModal;
      }
    },
    triggeredPostSelection: {
      get() {
        return this.$store.state.menu.triggerPostSelection;
      }
    },
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    singleResource: {
      get() {
        return this.$store.state.resource.singleResource;
      }
    }
  },
  mounted() {
    if (this.careplanId) {
      this.$store.commit("base/setLoadingPage", true, { root: 1 });
      this.$store
        .dispatch("feed/getCareplanInfo", this.careplanId)
        .then(res => {
          this.$store.commit("base/setLoadingPage", false, { root: 1 });
          this.isAdmin = !this.checkIfCreator(res) || this.isUserAdmin(res);
          this.getPostToValue(this.activeCareplan);
          this.getCareplanAvatar(this.activeCareplan);
        })
        .finally(() => {
          this.$store.commit("base/setLoadingPage", false, { root: 1 });
        });
    }
  },
  methods: {
    onImageLoading(v)  {
      this.isLoadingImages = v
    },
    convertReportName(name) {
      if (name == "concern") {
        return "Report Concern";
      } else if (name == "hero") {
        return "Report a Hero";
      } else if (name == "suggestion") {
        return "Share a story";
      } else if (name == "story") {
        return "Share a story";
      }
    },
    isUserAdmin(data) {
      if (data && data.permission) {
        if ("permission" in data.permission) {
          if (
            data.permission.permission == 511 ||
            data.permission.permission == 503 ||
            data.permission.permission == 0
          )
            return true;
        }
      } else {
        return false;
      }
    },
    checkIfCreator(data) {
      return !(data.submitted_by == this.profileInfo.id);
    },
    getPostToValue(data) {
      if (
        data.id == this.profileInfo.careplan_id ||
        data.id == this.profileInfo.private_careplan_id
      ) {
        this.careplanTitle = this.profileInfo.display_name;
        this.careplanType = "attachment";
      } else if (data.id == Cons[0].GROUP_ID.artwork) {
        this.careplanTitle = this.activeCareplan.title;
        this.careplanType = "attachment";
      } else {
        this.careplanTitle = this.activeCareplan.title;
        this.careplanType = "statement";
      }
    },

    getCareplanAvatar(data) {
      if (
        data.id == this.profileInfo.careplan_id ||
        data.id == this.profileInfo.private_careplan_id
      ) {
        this.careplanAvatar = this.userDisplayImage(this.profileInfo);
      } else {
        if (data.type == "private_journal")
          this.careplanAvatar = data.developer.avatar;
        else this.careplanAvatar = this.postPreviewImage(this.activeCareplan);
      }
    },

    closeModal() {
      // this.showInitialPage = false
      this.postItemForm.closeModal();
      if (this.triggeredPostSelection) {
        this.$store.commit("publicModule/setShowPostItemModal", false);
        this.$store.commit("menu/setPostSelectionModal", false);
        // this.$router.go(-1)
      } else {
        this.$store.commit("publicModule/setShowPostItemModal", false);
        // this.$router.go(-1)
      }
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage("user", user, "small");
    },
    postPreviewImage(careplan) {
      return Utils.getDisplayImage("group", careplan, "small");
    }
  }
};
</script>
